<template>
    <va-edit-layout>
        <RefundEventOrderCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></RefundEventOrderCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
